import React from 'react'
import { Button, Typography, IconButton } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { useStyles } from './Styles'
import AddNewDialog from '../../../Dialog/AddNewDialog'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import ReplayIcon from '@material-ui/icons/Replay'
import InvoiceItemForm from './InvoiceItemForm'
import { FormLoader } from '../../../Loader/FormLoader'
import AddBoxIcon from '@material-ui/icons/AddBox'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'
import { calculateDecimal } from '../../../../utils/helpers'
import CurrencyTooltip from './CurrencyTooltip'

const ItemsList = ({
                     isDialogOpen, isDialogView, cancelDialog, formClasses, currentSelectedRow, dialogActionSubmit, listingLoading,
                     listingData, listingPage, openDialog, locale, currentDialogAction, currencies, updateCurrenciesList, hasReferences,
                     listingCount, listingRowsPerPage, handleChangeListingPage, handleChangeListingRowsPerPage,
                     noPagination, noActions, documentType, currentCurrency, sameCurrency, isForeign, noName, isMultiForeign
                   }) => {
  const classes = useStyles()
  const intl = useIntl()
  const columns = [
    {
      name: 'deleted',
      label: '',
      options: {
        filter: false,
        display: 'false',
        viewColumns: false,
        print: false,
        sort: false,
        download: false
      }
    },
    {
      name: 'itemName',
      label: intl.formatMessage({ id: 'Fields.label.view.itemName' }),
      options: {
        filter: false,
        viewColumns: !noName,
        print: false,
        display: !!noName ? 'false' : 'true',
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.itemName || listingData[dataIndex]?.description || ''
          let uuid = listingData[dataIndex]?.invoiceUUID || ''
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <div>{value}</div>
              {!!uuid && <span><FormattedMessage id={'RelatedToInvoice'}/>: <NavLink
                to={formatRoute(NamedRoutes.msSingleInvoice, { id: uuid })}>{uuid}</NavLink></span>}
            </div>
        }
      }
    },
    {
      name: 'description',
      label: intl.formatMessage({ id: 'Fields.label.view.itemDescription' }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          // let hasName = !!listingData[dataIndex]?.itemName || false
          let value = listingData[dataIndex]?.description || ''
          // let uuid = listingData[dataIndex]?.invoiceUUID || ''
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <div>{value}</div>
              {/*{!!noName && !hasName && !!uuid && <span><FormattedMessage id={'RelatedToInvoice'}/>: <NavLink*/}
              {/*  to={formatRoute(NamedRoutes.msSingleInvoice, { id: uuid })}>{uuid}</NavLink></span>}*/}
            </div>
        }
      }
    },
    {
      name: 'itemType',
      label: intl.formatMessage({ id: 'Fields.label.view.itemType' }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false
      }
    },
    {
      name: 'itemCode',
      label: intl.formatMessage({ id: 'Fields.label.view.itemCode' }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.itemCode || ''
          let internalCode = listingData[dataIndex]?.internalCode || ''
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong>{value}</strong>
              {!!internalCode && <span>{internalCode}</span>}
            </div>
        }
      }
    },
    {
      name: 'quantity',
      label: intl.formatMessage({ id: 'Fields.label.view.itemQuantity' }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.quantity || ''
          let type = listingData[dataIndex]?.unitType || ''
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong>{value}</strong>
              {!!type && <span>{type}</span>}
            </div>
        }
      }
    },
    {
      name: 'unitAmount',
      label: intl.formatMessage({ id: 'Fields.label.view.itemUnitAmount' }, { currency: currentCurrency?.key }),
      // label: intl.formatMessage({ id: 'Fields.label.view.itemUnitAmount' }, { currency: !!currencyObject? <CurrencyTooltip header className={classes.currencyTooltip} currency={currencyObject?.currency} exchange={currencyObject?.currencyExchangeRate}/>:currentCurrency?.key }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.unitAmount : calculateDecimal(listingData[dataIndex]?.unitAmount * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.unitAmountForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.unitAmount}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'weightQuantity',
      label: intl.formatMessage({ id: 'Fields.label.weightQuantity' }),
      options: {
        filter: false,
        display: ['EI', 'EC', 'ED'].includes(documentType?.toUpperCase()) ? 'true' : 'false',
        viewColumns: ['EI', 'EC', 'ED'].includes(documentType?.toUpperCase()),
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.weightQuantity || ''
          let type = listingData[dataIndex]?.weightUnitType || ''
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong>{value}</strong>
              {!!type && <span>{type}</span>}
            </div>
        }
      }
    },
    {
      name: 'salesTotal',
      label: intl.formatMessage({ id: 'Fields.label.view.itemSalesTotal' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.salesTotal : calculateDecimal(listingData[dataIndex]?.salesTotal * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.salesTotalForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.salesTotal}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'discount',
      label: intl.formatMessage({ id: 'Fields.label.view.itemDiscount' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.discount || {}
          if (listingData[dataIndex]?.discountValue && !Object.keys(value)?.length) {
            value = {
              amount: listingData[dataIndex]?.discountValue,
              rate: listingData[dataIndex]?.discountRate
            }
          }
          let valueForeign = listingData[dataIndex]?.discountForeign || {}
          return !!Object.keys(value || {}).length &&
            <div className={classes.cellDataWrapper}>
              {!!isForeign ? <>
                  <strong>{!!sameCurrency ? valueForeign.amount : calculateDecimal(valueForeign.amount * listingData[dataIndex]?.currencyRate?.rate)}</strong>
                  <strong>( {!!sameCurrency ? value.amount : calculateDecimal(value.amount * listingData[dataIndex]?.currencyRate?.rate)}
                    <FormattedMessage id='EGP'/> )</strong>
                </> :
                <strong>{!!sameCurrency ? value.amount : calculateDecimal(value.amount * listingData[dataIndex]?.currencyRate?.rate)}</strong>
              }
              <span>{value.rate}%</span>
            </div>
        }
      }
    },
    {
      name: 'totalTaxableItems',
      label: intl.formatMessage({ id: 'Fields.label.view.totalTaxAmount' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? (listingData[dataIndex]?.totalTaxableItems || 0) : calculateDecimal(listingData[dataIndex]?.totalTaxableItems * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.totalTaxableItemsForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.totalTaxableFees}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'totalTaxableFees',
      label: intl.formatMessage({ id: 'Fields.label.view.itemTotalTaxableFees' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.totalTaxableFees : calculateDecimal(listingData[dataIndex]?.totalTaxableFees * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.totalTaxableFeesForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.totalTaxableFees}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'valueDifference',
      label: intl.formatMessage({ id: 'Fields.label.view.itemValueDifference' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.valueDifference : calculateDecimal(listingData[dataIndex]?.valueDifference * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.valueDifferenceForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.valueDifference}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'netTotal',
      label: intl.formatMessage({ id: 'Fields.label.view.itemNetTotal' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.netTotal : calculateDecimal(listingData[dataIndex]?.netTotal * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.netTotalForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.netTotal}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'itemsDiscount',
      label: intl.formatMessage({ id: 'Fields.label.view.itemsDiscount' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.itemsDiscount : calculateDecimal(listingData[dataIndex]?.itemsDiscount * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.itemsDiscountForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.itemsDiscount}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: 'total',
      label: intl.formatMessage({ id: 'Fields.label.view.itemTotal' }, { currency: currentCurrency?.key }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: true,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = !!sameCurrency ? listingData[dataIndex]?.total : calculateDecimal(listingData[dataIndex]?.total * listingData[dataIndex]?.currencyRate?.rate)
          let valueForeign = listingData[dataIndex]?.totalForeign || 0
          return !!isForeign ?
            <div className={classes.cellDataWrapper}>
              <strong><FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                className={classes.currencyTooltip}
                currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/></strong>
              <span>(&nbsp;<FormattedNumber value={value} minimumFractionDigits={2}/>&nbsp;<FormattedMessage
                id='EGP'/>&nbsp;)</span>
            </div> : (!!isMultiForeign ?
              <div className={classes.cellDataWrapper}>
                <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                {listingData[dataIndex]?.unitCurrency?.currencySold !== 'EGP' &&
                <span>(&nbsp;<FormattedNumber value={valueForeign} minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                  className={classes.currencyTooltip}
                  currency={listingData[dataIndex]?.unitCurrency?.currencySold}
                  exchange={listingData[dataIndex]?.unitCurrency?.currencyExchangeRate}/>&nbsp;)</span>}
              </div> : (!sameCurrency && listingData[dataIndex]?.amountSold !== 'EGP' ?
                  <div className={classes.cellDataWrapper}>
                    <strong><FormattedNumber value={value} minimumFractionDigits={2}/></strong>
                    <span>(&nbsp;<FormattedNumber value={listingData[dataIndex]?.total}
                                                  minimumFractionDigits={2}/>&nbsp;<CurrencyTooltip
                      className={classes.currencyTooltip}
                      currency={listingData[dataIndex]?.amountSold}
                      exchange={listingData[dataIndex]?.currencyRate?.rate}/>&nbsp;)</span>
                  </div> : <FormattedNumber value={value} minimumFractionDigits={2}/>
              ))
        }
      }
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        viewColumns: false,
        print: false,
        sort: false,
        display: !!noActions ? 'false' : 'true',
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let row = !!listingData?.length ? Object.assign({}, listingData[dataIndex]) : {}
          return !noActions && !!Object.keys(row || {}).length &&
            <div className={classes.EntityActionsWrapper}>
              {!row?.deleted &&
              <IconButton color="secondary" aria-label="Edit" onClick={(e) => {
                !!e?.preventDefault && e.preventDefault()
                !!e?.stopPropagation && e.stopPropagation()
                openDialog('edit', row, row.id)
              }}>
                <EditIcon/>
              </IconButton>
              }
              <IconButton color="secondary" aria-label="Delete" onClick={(e) => {
                !!e?.preventDefault && e.preventDefault()
                !!e?.stopPropagation && e.stopPropagation()
                openDialog('delete', row, row.id, null, null, !!hasReferences, !!row?.deleted)
              }}>
                {!!row?.deleted ? <ReplayIcon/> : <DeleteForeverIcon/>}
              </IconButton>
            </div>
        }
      }
    }
  ]
  const options = {
    filter: false,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: listingCount,
    search: false,
    jumpToPage: false,
    rowsPerPage: listingRowsPerPage,
    rowsPerPageOptions: [10, 25, 50, 100, 200],
    onChangePage: handleChangeListingPage,
    onChangeRowsPerPage: handleChangeListingRowsPerPage,
    page: listingPage > -1 ? listingPage : 0,
    confirmFilters: false,
    fixedHeader: true,
    fixedSelectColumn: false,
    print: false,
    download: false,
    pagination: !noPagination,
    elevation: !!noActions ? 0 : 4,
    setRowProps: (row, dataIndex, rowIndex) => {
      let classNames = []
      if (!!row[0]) {
        classNames.push(classes.virtualDeletedItem)
      }
      return { className: classNames }
    },
    // customToolbar: () => {
    //   return (
    //     !!userRole && userRole.toString() !== Configuration.CALL_CENTER_USER.toString() &&
    //     <Tooltip title={<FormattedMessage id='RequestsPageContent.SearchBar.Export.buttonLabel'/>}>
    //     <span className={'custom-toolbar-btn'}>
    //     <IconButton onClick={() => !!hasExport && !!exportListing && exportListing()}
    //                 disabled={!!listingExportLoading}
    //                 className={classes.iconButton}>
    //     <CloudDownloadIcon/>
    //       {!!listingExportLoading && <ButtonLoader loading={true}/>}
    //     </IconButton>
    //     </span>
    //     </Tooltip>
    //   )
    // },

    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Items.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Table.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Table.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Table.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Table.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Table.List.Table.RowsPerPage' }),
        jumpToPage: intl.formatMessage({ id: 'Table.List.Table.jumpToPage' }),
        displayRows: intl.formatMessage({ id: 'Table.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Table.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Table.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Table.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Table.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Table.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Table.List.Table.All' }),
        title: intl.formatMessage({ id: 'Table.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Table.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Table.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Table.List.Table.ShowHideColumns' })
      }
    }
  }
  return (
    <>
      {!noActions &&
      <AddNewDialog
        children={!!isDialogView && <InvoiceItemForm onSubmit={dialogActionSubmit} item={currentSelectedRow}
                                                     locale={locale} formClasses={formClasses} currencies={currencies}
                                                     updateCurrenciesList={updateCurrenciesList}
                                                     currentDialogAction={currentDialogAction}
                                                     documentType={documentType} cancelDialog={cancelDialog}/>}
        DialogTitle={<FormattedMessage id={`Invoice.Item.Form.Title.${currentDialogAction}`}
                                       values={{ code: currentSelectedRow?.itemCode || '' }}/>}
        isDialogOpen={isDialogOpen}
        cancelDialog={cancelDialog}/>
      }
      <div className={classes.itemsTableWrapper}>
        {!!listingLoading && <FormLoader loading={true}/>}
        <MUIDataTable
          title={
            <div className={classes.itemsHeader + (!!noActions ? ' info' : '')}>
              <Typography variant="h5">
                <FormattedMessage id={'InvoiceItems.TableTitle'}/>
              </Typography>
              {!noActions && !hasReferences &&
              <Button color={'secondary'} variant={'contained'}
                      className={classes.addNewLineBtn}
                      onClick={(e) => {
                        !!e?.preventDefault && e.preventDefault()
                        !!e?.stopPropagation && e.stopPropagation()
                        openDialog()
                      }}>
                <AddOutlinedIcon/> <FormattedMessage id={'InvoiceItems.addBtn.title'}/>
              </Button>
              }
            </div>
          }
          data={listingData}
          columns={columns}
          options={options}
        />
        {!noActions && !hasReferences &&
        <Button size={'small'} disableRipple color={'secondary'} onClick={() => openDialog()}
                className={classes.addNewItemButton}>
          <AddBoxIcon/>
          <FormattedMessage id={'InvoiceItems.addBtn.title'}/>
        </Button>
        }
      </div>
    </>
  )
}

export default ItemsList
